import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { APP_LOCALES } from 'locale/locale.config';

import { entities, cms, CmsProvider } from 'lib/cms';

import Container from 'components/shared/Container/Container';
import PageLayout from 'components/shared/PageLayout/PageLayout';
import PageHeader from 'components/shared/PageHeader/PageHeader';
import PageHead from 'components/shared/PageHead/PageHead';
import FaqCategory from 'components/Faq/FaqCategory';

const containerCss = css`
  margin-bottom: 60px;
`;

/**
 * An FAQ page for mobile app usage only.
 *
 * @param {object} props
 */
function Faq({ content, metadata }) {
  const { pageTitle, faqCategories } = content;

  return (
    <>
      <PageHead {...metadata} robots="noindex" />

      <PageLayout bottomPadding={0}>
        <PageHeader title={pageTitle} />

        <CmsProvider content={content}>
          <Container size="md" css={containerCss}>
            {faqCategories.map(({ categoryTitle, questions }, i) => (
              <FaqCategory
                key={`faq-category-${i}`}
                categoryTitle={categoryTitle}
                questions={questions}
              />
            ))}
          </Container>
        </CmsProvider>
      </PageLayout>
    </>
  );
}

Faq.propTypes = {
  content: PropTypes.object,
  metadata: PropTypes.object,
};

export async function getStaticPaths() {
  return {
    paths: [{ params: { locale: APP_LOCALES.UK } }],
    fallback: false,
  };
}

export async function getStaticProps() {
  const content = await cms.getEntry(entities.PAGE_FAQ, 'mobileApp');
  const { metadata } = content;

  return { props: { content, metadata } };
}

export default Faq;
